import React from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "./src/helpers/i18next";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => (
    <I18nextProvider i18n={i18next}>{element}</I18nextProvider>
);
const addGarfield = () => {
    let objectName = "gfd";
    window["GaNamespaceId"] = "PHONEPE_WEBSITE";
    window["GarfieldObjName"] = objectName;
    window[objectName] =
        window[objectName] ||
        function() {
            (window[objectName].q = window[objectName].q || []).push(arguments);
        };
    window[objectName].l = 1 * new Date();
    let a = document.createElement("script"),
        m = document.getElementsByTagName("script")[0];
    a.async = 1;
    a.src =
        "https://www.phonepe.com/webstatic/garfield-js/garfield-js.d667212e.js";
    m.parentNode.insertBefore(a, m);
};

export const onClientEntry = () => {
    window.onload = () => {
        addGarfield();
        window.gfd && window.gfd("create", { id: "PHONEPE_WEBSITE" });
        window.gfd && window.gfd("send", "pageview");
    };
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    window.gfd && window.gfd("send", "pageview");
};
